<template>
<div class="bg-white vh-100 position-fixed d-flex flex-column" style="right:0;top:0;">
  <div class="position-absolute" style="top: 11px; left: -40px; z-index: 1;">
    <button type="button" class="close" aria-label="Close" @click="close">
      <i class="material-icons md-24 text-white">
        close
      </i>
    </button>
  </div>
  <slot />
</div>
</template>

<script>
export default {
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style>

</style>
